module.exports = __webpack_public_path__ + "static/media/homeIcon.681a1f76.png";